import createAsyncAction from "../../utils/asyncAction";
import * as api from "../api/ylf/ylf_api";
import * as types from "../constants/ylf_constants";

const getYlfProductsTypes = {
  success: types.GET_YLF_PRODUCTS_SUCCESS,
  failure: types.GET_YLF_PRODUCTS_FAILURE,
};

export const getYlfProducts = createAsyncAction(
  api.getYlfProducts,
  getYlfProductsTypes,
);

export const registerYlf = (values) => async (dispatch) => {
  try {
    const response = await api.registerYlf(values);
    const { error, data } = response;

    if (error) {
      dispatch({ type: types.REGISTER_YLF_FAILURE, payload: error });
      return response;
    }

    dispatch({ type: types.REGISTER_YLF_SUCCESS, payload: data });
    return response;
  } catch (error) {
    const response = { error: error.message, data: null };
    dispatch({ type: types.REGISTER_YLF_FAILURE, payload: error.message });
    return response;
  }
};
